module.exports = __webpack_public_path__ + "static/media/quickbooksLogo.50ec5317.svg";